import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

import Localization from "../../Localization.jsx"
import RetrieverPage from "../../pages/RetrieverPage.jsx"

import {
  Icon,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  grey,
} from '@mui/material/colors'

const styles = {
  localeFilter: {
    display:'inline-block',
    verticalAlign:'middle',
    padding: '0 10px',
  },
};

class RetrieverBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      hasRouteData: false,
      submissionList: [],
      userOption: 0,
      isSharable: 0,
      showShareButton: false,
    };
    autoBind(this);
  }

  componentDidMount(){
    console.log('RetrieverBar rendered');
    console.log('in retrieverBar bounding rect: ', this.refs.div.getBoundingClientRect());
  }

  onBackClicked() {
    console.log('onbackclicked');
    this.setState({ hasRouteData: false });
    this.props.root.goBackHistory();
  }

  onListViewClicked() {
    console.log('onListViewClicked - redirecting to List View');
    this.setState({ hasRouteData: false });

    // Clean navigation to list view by replacing the current URL
    this.props.root.replaceHistory("/list");
    this.props.root.changeStatus(this.props.root.STATUS_VIEW_LOCALE());
    // ...and actually SHOW the list. A replace fires neither the POP nor the
    // PUSH branch of historyOnChange, so nothing else moves LocaleViewerPage
    // off the view it was on when the retriever was opened: a retriever entered
    // from the map view came back to the map with "/list" in the address bar,
    // under a button labelled "List View".
    if (this.props.root.refs.localeViewerPage) {
      this.props.root.refs.localeViewerPage.handleURLViewChange("/list");
    }
  }

  userOptionChanged(e) {
    console.log('Submission selected:', e.target.value);
    this.setState({ userOption: e.target.value });

    // Pass the selected submission ID to the parent for refreshing
    this.props.parent.refreshSubmissionDetail(e.target.value);
  }

  onShowSummaryClicked() {
    this.props.parent.setState({
      selectedIndex: -1,
      currentSubmissionId: null,
      currentUsername: null
    });
  }

  render() {
    console.log("rendering retriever bar");
    return (
      <div ref="div" style={{padding:"10px 0 10px 10px", backgroundColor:grey[300]}}>
        <Switch condition={this.props.parent.state.status}>
          <Case value={RetrieverPage.RET_VIEW_DATES()}>
            <Button
              color="secondary"
              variant="outlined"
              onClick={this.onBackClicked}
              style={{
                fontWeight: 700,
                fontSize: '1rem',
                padding: '8px 20px',
                borderWidth: '3px',
                borderColor: '#9c27b0',
                backgroundColor: 'rgba(156, 39, 176, 0.08)',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                color: '#9c27b0'
              }}
            >
              <Icon className="buttonIconLeft" style={{ fontSize: '1.5rem', marginRight: '8px', fontWeight: 'bold', color: '#9c27b0' }}>arrow_back</Icon>
              {Localization.strings.BACK}
            </Button>
          </Case>
          <Case value={RetrieverPage.RET_VIEW_SUBMISSION_GROUPS()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {/* LEFT group */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={this.onListViewClicked}
                  style={{
                    fontWeight: 700,
                    fontSize: '1rem',
                    padding: '8px 20px',
                    borderWidth: '3px',
                    borderColor: '#9c27b0',
                    backgroundColor: 'rgba(156, 39, 176, 0.08)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    color: '#9c27b0'
                  }}
                >
                  <Icon className="buttonIconLeft" style={{ fontSize: '1.5rem', marginRight: '8px', fontWeight: 'bold', color: '#9c27b0' }}>arrow_back</Icon>
                  {Localization.strings.LIST_VIEW}
                </Button>

              </div>

              {/* RIGHT group */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}> 
                {/* Moved submission-time dropdown into SubmissionDetail header card */}
                {/* Export, Share buttons moved to SubmissionDetail header card */}

                {/* Share button moved to SubmissionDetail header card */}
                
                {/* User Route moved to SubmissionDetail header card */}


              </div>
            </div>
          </Case>
        </Switch>
      </div>
    )
  }
}

export default RetrieverBar;
